export default "__VITE_ASSET__DPGksV8a__"